/**
 * module for location selection widget.
 */
define(
    'viewmodels/app/components/__reportScheduleForm',['jquery', 'knockout', 'lodash', 'atn/atn', 'dataSource/reporting/reporting',
        'dataSource/timeData', '../__allCharts', 'dataSource/userPreferences', '../analytics/__settings',
        'chartApi/index', '../__config', '../__utils', '../__subrouter', '../analytics/index', '../reporting/index'
    ],
    function (
        $, ko, _, atn, reportingDataSource, timeData, allCharts, userPreferences, analyticsConfig,
        chartApi, config, utils, router
    ) {
        'use strict';

        var matrixCharts = chartApi.matrixCharts;
        
        /**
         * [overlayVisible observable to get/set if the overlay is displayed or not.]
         * @type {ko.observable}
         */
        var overlayVisible = ko.observable(false);
        var isSummaryVisible = ko.observable(false);
        var isFrequencyVisible = ko.observable(false);
        var isEmailVisible = ko.observable(false);
        var rawDataReportColumns = ko.observableArray([]);

        var chartDescArray = ko.observableArray([]);
        // var chartConfigArray = ko.observableArray(null);
        /**
         * Setting up the form and validations
         */
        var errorObservable = ko.observable({});
        var nameInputBox = ko.observable(null);
        var formatForNumber = '{0:n0}';
        /**
         * observable for updating
         * @type {ko.observable(boolean)}
         */
        var updating = ko.observable(false);
        var isValid = ko.observable(true);
        var isRawDataMetricsEmpty = ko.observable(false);
        var globalValidationErrors = ko.observableArray([]);
        var validationErrors = ko.observableArray([]);
        var showAllMessages = ko.observable(false);
        var error = atn.utils.createComputedError(errorObservable, ['name']);
        var selectedScheduleObject = ko.observable(ko.mapping.fromJS(_.clone(reportingDataSource.nullReportObject)));
        var scheduleConfig = ko.trackableObservable(selectedScheduleObject, 'array');
        var messages = atn.config.messages;
        //  attaching savescheduleConfig to scheduleConfig
        //scheduleConfig.save = saveSchedule;
        //  attaching isValid to scheduleConfig
        scheduleConfig.isValid = isValid;
        scheduleConfig.init();

        var reportActiveDashboard = ko.observable();
        var reportActiveDashboardName = ko.observable();
        var isReady = ko.observable(false);

        var startMetricsRendering = ko.observable(false);

        scheduleConfig().rawDataColumnsConfig.subscribe(function () {
            isRawDataMetricsEmpty(scheduleConfig().rawDataColumnsConfig().length < 1);
        });

        isSummaryVisible.subscribe(function () {
            if(isSummaryVisible()) {
                showLoading();
                $.when(viewSummarySection()).done([hideLoading]);
            }
            else {
                hideLoading();
            }
        });
        
        reportActiveDashboard.subscribe(function (newid) {
            if (newid) {
                if (!scheduleConfig().reportScheduleId()) { // new report
                    var chartsList = [];
                    var populateReportName = false;
                    var reportName = scheduleConfig().name().toLowerCase().trim();
                    _.each(allCharts.dashboardList(), function (dashboard) {
                        if (reportActiveDashboard() === dashboard.id) {
                            reportActiveDashboardName(dashboard.title);
                            chartsList = dashboard.charts;
                        } else {
                            if (!reportName || reportName === dashboard.title.toLowerCase()) {
                                // report name is blank or matches with name of dashboard other than 
                                // the selected dashboard then populate it with current dashboard name
                                populateReportName = true;
                            }
                        }
                    });
                    if (populateReportName) {
                        scheduleConfig().name(reportActiveDashboardName());
                    }

                    var chartConfigList = _.map(chartsList, function (chartId) {
                        return chartApi.createChartComponent(chartId, userPreferences.userPreferences());
                    });

                    scheduleConfig().chartConfigs(
                        utils.reportConfigFromDashboard(
                            chartConfigList,
                            true
                        )
                    );
                    chartDescArray(
                        utils.reportSummaryFromDashboard(
                            chartConfigList,
                            true
                        )
                    );
                }
            }
        });

        /**
         * Observable to track if the values entered in the
         * frequency details are valid or not.
         */
        var isFrequencySettingsValid = ko.observable(true);
        var isSummarySettingsValid = ko.observable(true);
        var isEmailSettingsValid = ko.observable(true);

        var viewmodel = {
            activate: activate,
            attached: viewAttached,
            isReady: isReady,
            initReportForm: initReportForm,
            isInternetExplorer: atn.utils.isInternetExplorer,
            overlayVisible: overlayVisible,
            isSummaryVisible: isSummaryVisible,
            isFrequencyVisible: isFrequencyVisible,
            isEmailVisible: isEmailVisible,
            reportActiveDashboard: reportActiveDashboard,
            reportActiveDashboardName: reportActiveDashboardName,
            dashboardList: allCharts.dashboardList,
            setReportActiveDashboard: setReportActiveDashboard,
            scrollBarPosition: ko.observable(0),
            save: save,
            cancel: cancel,
            messages: messages,
            chartDescArray: chartDescArray,
            scheduleConfig: scheduleConfig,
            formatForNumber: formatForNumber,
            frequencyUnitData: reportingDataSource.frequencyUnitData,
            durationUnitData: reportingDataSource.durationUnitData,
            timezoneList: timeData.timezoneList,
            showAllMessages: showAllMessages,
            isValid: isValid,
            isRawDataMetricsEmpty: isRawDataMetricsEmpty,
            isPristine: scheduleConfig.isPristine,
            isFrequencySettingsValid: isFrequencySettingsValid,
            isSummarySettingsValid: isSummarySettingsValid,
            isEmailSettingsValid: isEmailSettingsValid,
            isLoading: reportingDataSource.isLoading,
            startMetricsRendering: startMetricsRendering,
            offsetFromSelectedTimezone: offsetFromSelectedTimezone,
            kendoDateFormat: atn.config.kendoDateFormat,
            kendoFullDateFormat: atn.config.kendoFullDateFormat,
            nameInputBox: nameInputBox,
            rawDataReportColumns: rawDataReportColumns,
            resetScheduleObject: resetScheduleObject,
            addMetric: addMetric,
            addAllMetric: addAllMetric,
            removeAllMetric: removeAllMetric,
            removeMetric: removeMetric,
            setMetricColumnHeader: setMetricColumnHeader,
            getFormatOptionsData: getFormatOptionsData,
            closeKendoDropdown: function (data, event) {
                var openDropdown = $(event.target).find(".k-dropdown-wrap.k-state-active");
                if (openDropdown.length) {
                    openDropdown.siblings("input").data("kendoDropDownList").close();
                }
            }
        };

        return viewmodel;

        function activate(operation, param) {
            //Set metric rendering flag is false because we don't need to render metric on activate function
            startMetricsRendering(false);
            
            var vm = this;
            isReady(false);
            if (!allCharts.dashboardList().length) {
                router.navigate("#app/analytics");
                return;
            }
            reportingDataSource.getRawDataReportColumns().done(function (reponseObservableArray) {
                rawDataReportColumns(reponseObservableArray());
                if (operation === 'edit') {
                    initReportForm({
                        id: config.REPORT_SCHEDULE_CONTEXT_IDS.REPORTS,
                        reportId: param
                    });
                } else {
                    initReportForm({
                        id: config.REPORT_SCHEDULE_CONTEXT_IDS.DASHBOARD,
                        reportType: param
                    });
                }
            });
        }

        function viewAttached() {
            document.getElementById("report-schedule-form").scrollTop = 0;
        }

        function resetScheduleObject() {
            scheduleConfig.reset();
        }

        function save(passedContext) {
            var promise;
            var reportType = scheduleConfig().reportType();
            /**
             * passedContext will be true when the unsaved changes popup is
             * used to save teh report.        
             */
            if (isValid()) {
                updating(true);
                if (scheduleConfig().reportScheduleId()) {
                    //edit an existing schedule using the PUT http call.
                    promise = reportingDataSource.updateReport(scheduleConfig, errorObservable);

                    promise.done(function () {
                        atn.toasterRegistry.addToasterMessage(messages.reporting.updateSuccess);
                        router.navigate("#app/reporting/" + reportType);
                    });

                    promise.fail(function () {
                        atn.toasterRegistry.addToasterMessage(messages.reporting.updateFailed);
                        atn.toasterRegistry.addToasterMessage([globalValidationErrors().concat(error.__global())]);
                    });
                } else {
                    //create a new schedule using the POST http call.
                    promise = reportingDataSource.addReport(scheduleConfig, errorObservable);

                    promise.done(function () {
                        atn.toasterRegistry.addToasterMessage(messages.reporting.saveSuccess);
                        router.navigate("#app/reporting/" + reportType);
                    });

                    promise.fail(function () {
                        atn.toasterRegistry.addToasterMessage(messages.reporting.saveFailed);
                        atn.toasterRegistry.addToasterMessage([globalValidationErrors().concat(error.__global())]);
                    });
                }

                promise.done(function () {
                    updating(false);
                    toggleOverlay();
                });

                promise.fail(function () {
                    updating(false);
                    showAllMessages(true);
                });

            } else {
                showAllMessages(true);
                promise = atn.utils.dummySuccessDeferred();
            }

            return promise;
        }

        function focusOnReportNameInput() {
            //                nameInputBox().focus();
        }


        function initReportForm(context) {
            var promise;
            focusOnReportNameInput();
            if (config.REPORT_SCHEDULE_CONTEXT_IDS.REPORTS === context.id && context.reportId) {
                promise = reportingDataSource.getSingleReport(context.reportId);
                promise.done(function () {
                    var storedSchedule = reportingDataSource.singleReport();
                    if (storedSchedule) {
                        _.each(storedSchedule.rawDataColumnsConfig(), function (column) {
                            var hiddenColumnIndex = _.findIndex(reportingDataSource.hiddenColumns, function (hiddenColumn) {
                                return hiddenColumn && (hiddenColumn.id() === column.reportColumnId());
                            });
                            if (hiddenColumnIndex !== -1) {
                                rawDataReportColumns.push(reportingDataSource.hiddenColumns[hiddenColumnIndex]);
                                reportingDataSource.hiddenColumns.splice(hiddenColumnIndex, 1);
                            }
                        });
                        selectedScheduleObject(storedSchedule);
                        context.storedSchedule = storedSchedule;
                        initializeFormData(context);
                    }
                });
            } else {                
                var newReportObject = JSON.parse(JSON.stringify(reportingDataSource.nullReportObject));
                if (context.reportType) {
                    newReportObject.reportType = context.reportType;
                }
                var timezoneObj = _.find(timeData.timezoneList(), function (timeZone) {
                    return timeZone.value() === newReportObject.timezone;
                });
                var timezoneOffset = timezoneObj.offset();
                
                //Set the start and end date
                var currentDate = new Date();
                newReportObject.metricDurationStartDate = atn.utils.translateUtcFromRemoteTzToLocalTz(new Date().setTime(currentDate.getTime() - 30 * 24 * 60 * 60 * 1000), timezoneOffset);
                newReportObject.metricDurationEndDate = atn.utils.translateUtcFromRemoteTzToLocalTz(currentDate, timezoneOffset);
              
                selectedScheduleObject(ko.mapping.fromJS(newReportObject));
                initializeFormData(context);
            }
        }

        function initializeFormData(context) {
            scheduleConfig().reportType(null);
            if (!scheduleConfig().reportScheduleId()) {
                scheduleConfig().oneTimeScheduleTime(new Date());
                scheduleConfig().recurringScheduleStart(new Date());
                scheduleConfig().recurringScheduleEnd(new Date());
                scheduleConfig().oneTimeScheduleTime(null);
                scheduleConfig().recurringScheduleStart(null);
                scheduleConfig().recurringScheduleEnd(null);
            }
            scheduleConfig.reset();
            if (viewmodel && viewmodel.cleanup) {
                viewmodel.cleanup();
            }
            errorObservable({});
            isReady(true);

            if (config.REPORT_SCHEDULE_CONTEXT_IDS.REPORTS === context.id && context.storedSchedule) {
                chartDescArray(
                    utils.reportSummaryFromModel(context.storedSchedule.chartConfigs())
                );
            } else {
                reportActiveDashboard(null);
                reportActiveDashboard(allCharts.activeDashboard());
                scheduleConfig().reportType.subscribe(function (type) {
                    if (!scheduleConfig().reportScheduleId()) {
                        if (type === "RAW_DATA") {
                            scheduleConfig().name("Metrics Report");
                        } else if (type === "CHART") {
                            scheduleConfig().name(reportActiveDashboardName());
                        }
                    }
                });
                scheduleConfig().reportType.valueHasMutated();
            }
            showAllMessages(false);
            updating(false);
            isSummaryVisible(false);
            isFrequencyVisible(false);
            isEmailVisible(false);
            toggleOverlay();
        }

        function toggleOverlay() {
            overlayVisible(!overlayVisible());
        }

        function cancel() {
            isReady(false);
            router.navigate("#app/reporting/" + scheduleConfig().reportType());
        }

        function addMetric($index) {
            var newMetric = ko.mapping.fromJS(_.clone(reportingDataSource.nullReportObject.rawDataColumnsConfig[0]));
            if ($index) {
                scheduleConfig().rawDataColumnsConfig.splice($index() + 1, 0, newMetric);
            } else {
                scheduleConfig().rawDataColumnsConfig.push(newMetric);
            }
        }

        function pushMetrics() {
            var d = new $.Deferred();
            setTimeout((function() {
                var metricObjKeys = Object.keys(reportingDataSource.singleReportObj);
                //Add all metrics
                _.forEach(rawDataReportColumns(), function(metric, index) {
                    var obj = {};
                    obj[metricObjKeys[0]] = metric.dataFormats()[0];
                    obj[metricObjKeys[1]] = metric.id();
                    obj[metricObjKeys[2]] = 1;
                    obj[metricObjKeys[3]] = metric.defaultColumnName();
                    scheduleConfig().rawDataColumnsConfig.push(ko.mapping.fromJS(_.clone(obj)));
                });
                d.resolve();
            }),1000);
            return d.promise();
        }

        function showLoading() {
            reportingDataSource.isLoading(true);
        }
        
        function hideLoading() {
            reportingDataSource.isLoading(false);
        }

        function addAllMetric() {
            //Show loading
            showLoading();
            
            //Push all metrics
            $.when(pushMetrics()).done([hideLoading]);
        }
        
        function viewSummarySection() {
            var d = new $.Deferred();
            setTimeout((function() {
                startMetricsRendering(true);
                d.resolve();
           }),1000);
            return d.promise();
        }

        //Remove all previous added metrics
        function removeAllMetric() {
            scheduleConfig().rawDataColumnsConfig.splice(0);
        }

        function removeMetric($index) {
            if ($index && scheduleConfig().rawDataColumnsConfig().length > 1) {
                scheduleConfig().rawDataColumnsConfig.splice($index(), 1);
            }
        }

        function setMetricColumnHeader($index, metric) {
            if ($index) {
                var metricObject = scheduleConfig().rawDataColumnsConfig()[$index()];
                metricObject.reportColumnUserProvidedName(metric.text());
                window.setTimeout(function () {
                    var validFormats = reportingDataSource.validRawDataFormatsHash[metricObject.reportColumnId()];
                    metricObject.reportColumnDataFormat(validFormats[0]);
                }, 100);
            }
        }

        function getFormatOptionsData($data) {
            if ($data.reportColumnId) {
                return ko.computed(function () {
                    var validFormats = reportingDataSource.validRawDataFormatsHash[$data.reportColumnId()];
                    return _.filter(reportingDataSource.formatOptionsData, function (option) {
                        return (validFormats.indexOf(option.id) !== -1);
                    });
                });
            }
            return reportingDataSource.formatOptionsData;
        }

        /**
         * [offsetFromSelectedTimezone find offset from selected timezone name]
         * @param  {string} tz [timezone name]
         * @return {Number}    [offset in milliseconds]
         */
        function offsetFromSelectedTimezone(tz) {
            var retVal,
                tzObj = _.find(timeData.timezoneList(), function (timeZone) {
                    return timeZone.value() === tz;
                });

            if (tzObj) {
                retVal = tzObj.offset();
            } else {
                retVal = null;
            }

            return retVal;
        }

        function setReportActiveDashboard(dashboard) {
            if (!scheduleConfig().reportScheduleId() && isSummaryVisible()) { // new report
                reportActiveDashboard(dashboard.id);
            }
        }

    });

